import request from "./request";

const api = {
  getUserTokenRecordList: "user_token_record/getUserTokenRecordList",
};
export default {
  getUserTokenRecordList(parameter) {
    return request({
      url: api.getUserTokenRecordList,
      method: "POST",
      data: parameter,
    });
  },
};
